import moment from "moment";

const errorEventLogPath = process.env.REACT_APP_API_URL + "/eventlog/log";

const sendErrorEventLog = async (details, error) => {
  console.log("sendErrorEventLog called...", details, error);
  let msg = "";
  if (!error) {
    msg = "";
  } else if (typeof error == "string") {
    msg = error;
  } else if (error.response) {
    msg = error.response || JSON.stringify(error.response);
  } else if (error.err && error.err.message) {
    msg = error.err.message;
  }

  if (typeof msg == "object" && (msg.status || msg.statusText)) {
    msg = `Error Code: ${msg.status} - ${msg.statusText}`;
  }

  const formData = {
    DateTime: moment(new Date()).format("YYYY-MM-DD hh:mm A"),
    Message: msg || "",
    Details: details || "",
    SeverityLevel: 3,
    Source: 2,
  };

  try {
    const response = await fetch(errorEventLogPath, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    if (response.status !== 200 && response.status !== 201) {
      console.log(
        "Looks like there was a problem. Status Code: " + response.status,
      );
    }
  } catch (err) {
    console.log("Error sending error log: ", err);
  }
};

export default sendErrorEventLog;
